import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { OrderService } from '@app/shared/services/order/order.service';
import { NotificationService } from '@app/core/services/notification/notification.service';
import { LoaderService } from '@app/core/services/loader/loader.service';
import { EncrDecrService } from '../services/encr-decr-service.service';
import { CryptoKeyValue } from '../constants';

@Injectable()
export class OrderDetailResolver implements Resolve<any> {
  constructor(private orderService: OrderService) { }

    public orderDetail: any = undefined;
  resolve(route: ActivatedRouteSnapshot) {
        if (this.orderDetail) {
            return this.getSavedOrderDetail();
        } else {
            return this.getOrderDetailFromApi(route.params.orderno);
        }
    }

    private getSavedOrderDetail(): any {
        return of(this.orderDetail);
    }

  private getOrderDetailFromApi(orderno: string): any {
    return this.orderService.GetOrderDetail(orderno);
  }
}
